import {
  Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputColor, InputType } from 'src/app/interfaces/ui.theme';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
})
export class InputComponent implements OnInit, OnChanges {
  @Input() id!: string;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type: InputType = 'text';
  @Input() value: string = '';
  @Input() name: string = '';
  @Input() helperText: string = '';
  @Input() disabled = false;
  @Input() color!: InputColor;
  @Input() width: string = '';
  @Input() dense: boolean = false;
  @Input() required: boolean = false;
  @Input() autocomplete: string = '';
  @Input() control!: any;
  @Input() currency: string = 'USD';
  @Input() mode: string = '';
  @Input() mask: string = '(999) 999-9999';
  @Input() inputType: string = 'text';
  @Input() phoneIncompleteMessage = 'Please enter a valid phone number.';
  phoneIncompleteError = '';

  colorClass = {
    error: 'text-error border-error focus:border-red-500',
    success: 'text-green-500 border-green-200 focus:border-green-500',
    warning: 'text-yellow-500 border-yellow-200 focus:border-yellow-500',
  };

  @Output() sendChange = new EventEmitter();
  @Output() sendBlurEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.syncDisabledWithControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] || changes['control']) {
      this.syncDisabledWithControl();
    }
  }

  /** Reactive forms ignore `[disabled]` on the element; sync via the control instead. */
  private syncDisabledWithControl(): void {
    const control = this.control as AbstractControl | null;
    if (!control) {
      return;
    }
    if (this.disabled) {
      if (control.enabled) {
        control.disable({ emitEvent: false });
      }
    } else if (control.disabled) {
      control.enable({ emitEvent: false });
    }
  }

  onChange(event: unknown) {
    this.sendChange.emit(event);
  }

  onBlur(event: Event) {
    this.sendBlurEvent.emit(event);
  }

  private phoneDigitsOnly(v: unknown): string {
    if (v == null) return '';
    return String(v).replace(/\D/g, '');
  }

  onPhoneChange(val: unknown) {
    const digits = this.phoneDigitsOnly(val);
    if (digits.length === 0 || digits.length === 10) {
      this.phoneIncompleteError = '';
    }
    this.onChange(val);
  }

  onPhoneBlur(event: Event) {
    const digits = this.phoneDigitsOnly(this.value);
    if (digits.length > 0 && digits.length < 10) {
      this.phoneIncompleteError = this.phoneIncompleteMessage;
    } else {
      this.phoneIncompleteError = '';
    }
    this.sendBlurEvent.emit(event);
  }
}
